import { axios } from '@ben/api/axios';

export const addTag = (tagName: string) => {
  return async (): Promise<unknown> => {
    const response = await axios.post<unknown>(`tags/`, { name: tagName });
    return response?.data;
  };
};
